import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getPriceLadderChart2 } from 'gqlQueries/priceLadder';
import { priceLadderAttributeLevelChart2Parser } from 'parser/priceLadderParser';
const errorMessage: string = 'Something went wrong!';

function useFetchPriceLadderChart2() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    const [fetchPriceLadderChart2, { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError }] =
        useLazyQuery(getPriceLadderChart2, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPricePointChangeData } = payload;
            if (
                getPricePointChangeData &&
                'values' in getPricePointChangeData &&
                Array.isArray(getPricePointChangeData.values)
            ) {
                rawDataRef.current.push(...getPricePointChangeData?.values);
                const parsedChartData = priceLadderAttributeLevelChart2Parser(
                    rawDataRef.current,
                    getPricePointChangeData?.baseLineValue,
                );
                setData({ chartData: parsedChartData });
                setCount(getPricePointChangeData?.count || 0);
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        rawDataRef.current = [];
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        fetchPriceLadderChart2: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            if (commonConfig.offset === variables.variables?.offset) {
                rawDataRef.current = [];
                setCount(0);
            }
            setData(null);
            setLoading(true);
            setError(null);
            fetchPriceLadderChart2(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchPriceLadderChart2 };
